(function () {
  function initWishlistPages(scope) {
    const container = scope && typeof scope.querySelectorAll === 'function' ? scope : document;

    container.querySelectorAll('[data-wc-wishlist-page]').forEach((root) => {
      if (root.dataset.wcWishlistPageInitialized === 'true') {
        return;
      }

      root.dataset.wcWishlistPageInitialized = 'true';

      const storageKey = 'wc_wishlist_products';

      const grid = root.querySelector('[data-wc-wishlist-grid]');
      const loading = root.querySelector('[data-wc-wishlist-loading]');
      const empty = root.querySelector('[data-wc-wishlist-empty]');
      const toolbar = root.querySelector('[data-wc-wishlist-toolbar]');
      const countNode = root.querySelector('[data-wc-wishlist-count]');
      const clearButton = root.querySelector('[data-wc-wishlist-clear]');
      const shareButton = root.querySelector('[data-wc-wishlist-share]');

      const moneyFormat = root.dataset.moneyFormat || '{{amount}}';
      const removeLabel = root.dataset.removeLabel || 'Remove from wishlist';
      const addLabel = root.dataset.addLabel || 'Add to bag';
      const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';

      function getWishlist() {
        try {
          const raw = localStorage.getItem(storageKey);
          const items = JSON.parse(raw) || [];

          if (!Array.isArray(items)) {
            return [];
          }

          return Array.from(new Set(items.filter(Boolean)));
        } catch (error) {
          return [];
        }
      }

      function setWishlist(items) {
        const cleanItems = Array.from(new Set(items.filter(Boolean)));

        localStorage.setItem(storageKey, JSON.stringify(cleanItems));

        window.dispatchEvent(
          new CustomEvent('wc:wishlist:updated', {
            detail: {
              items: cleanItems
            }
          })
        );
      }

      function getSharedItemsFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const items = params.get('items');

        if (!items) {
          return [];
        }

        return Array.from(
          new Set(
            items
              .split(',')
              .map((item) => item.trim())
              .filter(Boolean)
          )
        );
      }

      let sharedWishlistItems = getSharedItemsFromUrl();

      function isSharedWishlist() {
        return sharedWishlistItems.length > 0;
      }

      function getActiveWishlistItems() {
        return isSharedWishlist() ? sharedWishlistItems : getWishlist();
      }

      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function formatMoney(cents) {
        const value = Number(cents || 0);
        const amount = (value / 100).toFixed(2);
        const amountNoDecimals = String(Math.round(value / 100));
        const amountWithComma = amount.replace('.', ',');

        return moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountWithComma);
      }

      function getProductImage(product) {
        if (product.featured_image) {
          return product.featured_image;
        }

        if (Array.isArray(product.images) && product.images.length) {
          return product.images[0];
        }

        return '';
      }

      function getProductSecondImage(product) {
        if (Array.isArray(product.images) && product.images.length > 1) {
          return product.images[1];
        }

        return '';
      }

      function getAvailableVariant(product) {
        if (!Array.isArray(product.variants)) {
          return null;
        }

        return product.variants.find((variant) => variant.available) || product.variants[0] || null;
      }

      async function fetchProduct(handle) {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Product not found: ${handle}`);
        }

        return response.json();
      }

      function renderMissingCard(handle) {
        const card = document.createElement('article');

        card.className = 'wc-wishlist-card wc-wishlist-card--missing';
        card.dataset.handle = handle;

        card.innerHTML = `
          <button
            type="button"
            class="wc-wishlist-card__remove"
            data-wc-remove-wishlist-item="${escapeHtml(handle)}"
            aria-label="${escapeHtml(removeLabel)}"
            title="${escapeHtml(removeLabel)}"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M18.3 5.71 16.89 4.3 12 9.17 7.11 4.3 5.7 5.71 10.59 10.6 5.7 15.49 7.11 16.9 12 12.01 16.89 16.9 18.3 15.49 13.41 10.6 18.3 5.71Z"></path>
            </svg>
          </button>

          <p>This saved product is no longer available.</p>
        `;

        return card;
      }

      function renderProductCard(product) {
        const variant = getAvailableVariant(product);
        const image = getProductImage(product);
        const secondImage = getProductSecondImage(product);
        const productUrl = `/products/${product.handle}`;

        const compareAtPrice =
          variant && variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price
            : null;

        const card = document.createElement('article');

        card.className = 'product-card product-card--modern wc-inline-card wc-wishlist-card';
        card.dataset.handle = product.handle;

        card.innerHTML = `
          <div class="wc-wishlist-card__media-wrap">
            <a
              class="product-card__media ratio-portrait${secondImage ? ' has-second-image' : ''}"
              href="${escapeHtml(productUrl)}"
              aria-label="${escapeHtml(product.title)}"
            >
              ${
                image
                  ? `<img
                      class="product-card__image product-card__image--primary"
                      src="${escapeHtml(image)}"
                      alt="${escapeHtml(product.title)}"
                      loading="lazy"
                    >`
                  : `<div class="product-card__placeholder">${escapeHtml(product.title)}</div>`
              }

              ${
                secondImage
                  ? `<img
                      class="product-card__image product-card__image--second"
                      src="${escapeHtml(secondImage)}"
                      alt="${escapeHtml(product.title)}"
                      loading="lazy"
                    >`
                  : ''
              }
            </a>

            <button
              type="button"
              class="wc-wishlist-card__remove"
              data-wc-remove-wishlist-item="${escapeHtml(product.handle)}"
              aria-label="${escapeHtml(removeLabel)}"
              title="${escapeHtml(removeLabel)}"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18.3 5.71 16.89 4.3 12 9.17 7.11 4.3 5.7 5.71 10.59 10.6 5.7 15.49 7.11 16.9 12 12.01 16.89 16.9 18.3 15.49 13.41 10.6 18.3 5.71Z"></path>
              </svg>
            </button>
          </div>

          <div class="product-card__content">
            <div class="product-card__title-price">
              ${
                variant
                  ? `
                    <div class="price${compareAtPrice ? ' price--sale' : ''}">
                      <span class="price__regular">
                        ${formatMoney(variant.price)}
                      </span>

                      ${
                        compareAtPrice
                          ? `<span class="price__compare">
                              ${formatMoney(compareAtPrice)}
                            </span>`
                          : ''
                      }
                    </div>
                  `
                  : ''
              }

              <h3 class="product-card__title">
                <a href="${escapeHtml(productUrl)}">
                  ${escapeHtml(product.title)}
                </a>
              </h3>
            </div>

            </div>
          </div>
        `;

        return card;
      }

      function updateState(items) {
        const count = items.length;

        if (loading) {
          loading.hidden = true;
        }

        if (toolbar) {
          toolbar.hidden = count === 0;
        }

        if (countNode) {
          countNode.textContent = count === 1 ? '1 saved dress' : `${count} saved dresses`;
        }

        if (empty) {
          empty.hidden = count !== 0;
        }

        if (grid) {
          grid.hidden = count === 0;
        }
      }

      async function renderWishlist() {
        const items = getActiveWishlistItems();

        if (!grid) {
          if (loading) {
            loading.hidden = true;
          }

          return;
        }

        grid.innerHTML = '';

        if (loading) {
          loading.hidden = false;
        }

        if (!items.length) {
          updateState(items);
          return;
        }

        const cards = await Promise.all(
          items.map(async (handle) => {
            try {
              const product = await fetchProduct(handle);
              return renderProductCard(product);
            } catch (error) {
              console.warn('Wishlist product error:', error);
              return renderMissingCard(handle);
            }
          })
        );

        grid.innerHTML = '';

        cards.forEach((card) => {
          grid.appendChild(card);
        });

        updateState(items);
      }

      function updateSharedUrl() {
        const url = new URL(window.location.href);

        if (sharedWishlistItems.length) {
          url.searchParams.set('items', sharedWishlistItems.join(','));
        } else {
          url.searchParams.delete('items');
        }

        window.history.replaceState({}, '', url.toString());
      }

      function removeItem(handle) {
        if (isSharedWishlist()) {
          sharedWishlistItems = sharedWishlistItems.filter((item) => item !== handle);
          updateSharedUrl();
          renderWishlist().catch(handleWishlistError);
          return;
        }

        const items = getWishlist().filter((item) => item !== handle);

        setWishlist(items);
        renderWishlist().catch(handleWishlistError);
      }

      async function addVariantToCart(variantId, button) {
        if (!variantId || !button) {
          return;
        }

        const originalText = button.textContent;

        button.disabled = true;
        button.textContent = 'Adding...';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1
            })
          });

          if (!response.ok) {
            throw new Error('Could not add item to cart');
          }

          button.textContent = 'Added';

          window.dispatchEvent(new CustomEvent('wc:cart:updated'));

          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1600);
        } catch (error) {
          console.warn('Wishlist add to cart error:', error);

          button.textContent = 'Error';

          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1600);
        }
      }

      function buildShareUrl() {
        const items = getActiveWishlistItems();

        if (!items.length) {
          return '';
        }

        const url = new URL(window.location.href);

        url.searchParams.set('items', items.join(','));
        url.hash = '';

        return url.toString();
      }

      function copyToClipboard(value) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(value);
        }

        const input = document.createElement('textarea');

        input.value = value;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        input.style.top = '-9999px';

        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);

        return Promise.resolve();
      }

      async function shareWishlist() {
        if (!shareButton) {
          return;
        }

        const shareUrl = buildShareUrl();

        if (!shareUrl) {
          return;
        }

        const originalText = shareButton.textContent;

        if (navigator.share) {
          try {
            await navigator.share({
              title: 'My Wedcharm Wishlist',
              text: 'Here are my favorite wedding dresses from Wedcharm.',
              url: shareUrl
            });

            return;
          } catch (error) {
            if (error && error.name === 'AbortError') {
              return;
            }
          }
        }

        try {
          await copyToClipboard(shareUrl);

          shareButton.textContent = 'Link copied';

          setTimeout(() => {
            shareButton.textContent = originalText;
          }, 1800);
        } catch (error) {
          shareButton.textContent = 'Could not copy';

          setTimeout(() => {
            shareButton.textContent = originalText;
          }, 1800);
        }
      }

      function handleWishlistError(error) {
        console.error('Wishlist error:', error);

        if (loading) {
          loading.hidden = true;
        }

        if (empty) {
          empty.hidden = false;
        }

        if (toolbar) {
          toolbar.hidden = true;
        }

        if (grid) {
          grid.innerHTML = '';
          grid.hidden = true;
        }
      }

      root.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-wc-remove-wishlist-item]');

        if (removeButton) {
          event.preventDefault();
          event.stopPropagation();

          removeItem(removeButton.dataset.wcRemoveWishlistItem);
          return;
        }

        const atcButton = event.target.closest('[data-wc-wishlist-atc]');

        if (atcButton) {
          event.preventDefault();
          event.stopPropagation();

          addVariantToCart(atcButton.dataset.variantId, atcButton);
        }
      });

      if (shareButton) {
        shareButton.addEventListener('click', shareWishlist);
      }

      if (clearButton) {
        clearButton.addEventListener('click', () => {
          if (isSharedWishlist()) {
            sharedWishlistItems = [];
            updateSharedUrl();
            renderWishlist().catch(handleWishlistError);
            return;
          }

          setWishlist([]);
          renderWishlist().catch(handleWishlistError);
        });
      }

      window.addEventListener('storage', (event) => {
        if (event.key === storageKey && !isSharedWishlist()) {
          renderWishlist().catch(handleWishlistError);
        }
      });

      window.addEventListener('wc:wishlist:updated', () => {
        if (!isSharedWishlist()) {
          renderWishlist().catch(handleWishlistError);
        }
      });

      renderWishlist().catch(handleWishlistError);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWishlistPages(document));
  } else {
    initWishlistPages(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initWishlistPages(event.target || document);
  });
})();